import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "reload-tab"

  connect() {
    super.connect()
    const tab = this.bridgeElement.bridgeAttribute("tab") || "all"
    this.send("reload", { tab }, () => {})
  }
}
